import { PowerIcon } from '@shared/components/Icons';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export const NavbarPowerButton: FC = () => {
  const { t } = useTranslation();

  return (
    <div className="flex h-[64px] w-full items-center justify-center transition-all duration-200 hover:brightness-125">
      <div className="xs:px-4 border-image-power bg-power-button-gradient flex h-[52px] w-full rounded-md px-2 sm:h-[42px] lg:px-3">
        <Link
          to={import.meta.env.VITE_POWER_PROTOCOL_URL}
          className="font-poppins flex flex-row items-center justify-center gap-2 text-[17.5px] font-bold tracking-normal text-[#ECEAED] lg:text-[12.5px] xl:text-[17.5px]"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="lg:hidden">
            {t('navbar.power')}
          </div>
          <PowerIcon className="size-[34px] sm:size-[24px]" />
        </Link>
      </div>
    </div>
  );
};
